// extracted by mini-css-extract-plugin
var _1 = "pYov6";
var _2 = "z5SNc";
var _3 = "HsBja";
var _4 = "u7n30";
var _5 = "vZhVA";
export { _1 as "blurred", _2 as "darkGradient", _3 as "gradient", _4 as "lightGradient", _5 as "neutralBackground" }
